var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.UserSearch,"trigger-on-focus":false,"size":"mini","value-key":"name","clearable":"","placeholder":"成员:例如'许XX''"},on:{"select":_vm.UserSelect,"clear":_vm.UserClear,"input":_vm.UserInput},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})
}
var staticRenderFns = []

export { render, staticRenderFns }